import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const PersianPalace = {
  id: "39",
  name: "Persian Palace",
  width: 4,
  height: 4,

  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Persian_Palace",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Persian_Palace',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asCallbackWithLevel(
          (level) => level === 1 ? 0 : 1
        )
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include food, coins or customization')
      ,
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,0,13,13,18,18,22,22,22,27,27,27,31,31,34,34,37,37,37,41,41,41,44,44,46,46,48,48,48,52,52,52,55,55,57,57,59,59,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82
        ],
        bronzeAge: [
          0,0,15,15,21,21,25,25,25,31,31,31,37,37,40,40,43,43,43,47,47,47,52,52,54,54,57,57,57,60,60,60,64,64,66,66,68,68,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114
        ],
        minoanEra: [
          0,0,21,21,29,29,35,35,35,44,44,44,51,51,56,56,60,60,60,66,66,66,72,72,76,76,79,79,79,84,84,84,89,89,93,93,96,96,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142
        ],
        classicGreece: [
          0,0,34,34,46,46,57,57,57,70,70,70,82,82,89,89,96,96,96,106,106,106,115,115,121,121,127,127,127,135,135,135,143,143,148,148,154,154,161,165,168,172,175,179,182,186,189,193,196,200,203,207,210,214,217,221,224,228,231,235
        ],
        earlyRome: [
          0,0,42,42,57,57,69,69,69,86,86,86,100,100,109,109,118,118,118,130,130,130,141,141,148,148,155,155,155,165,165,165,175,175,181,181,188,188,197,202,206,211,215,220,224,229,233,238,242,247,251,256,260,265,269,274,278,283,287,292
        ],
        romanEmpire: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        byzantineEra: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        ageOfTheFranks: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        feudalAge: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        iberianEra: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        kingdomOfSicily: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        highMiddleAges: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        earlyGothicEra: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
        lateGothicEra: [
          0,0,49,49,67,67,82,82,82,101,101,101,118,118,129,129,139,139,139,153,153,153,167,167,175,175,183,183,183,195,195,195,207,207,214,214,222,222,232,237,242,247,252,257,262,267,272,277,282,287,292,297,302,307,312,317,322,327,332,337
        ],
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          10,10,10,23,23,23,23,35,35,35,42,42,42,49,49,49,49,57,57,57,62,62,62,67,67,67,67,74,74,74,78,78,78,83,83,83,83,89,90,92,93,95,96,98,99,101,102,104,105,107,108,110,111,113,114,116,117,119,120,122
        ],
        bronzeAge: [
          15,15,15,43,43,43,43,65,65,65,79,79,79,91,91,91,91,106,106,106,117,117,117,126,126,126,126,138,138,138,147,147,147,156,156,156,156,166,168,171,173,176,178,181,183,186,188,191,193,196,198,201,203,206,208,211,213,216,218,221
        ],
        minoanEra: [
          25,25,25,63,63,63,63,96,96,96,116,116,116,134,134,134,134,156,156,156,171,171,171,185,185,185,185,203,203,203,216,216,216,228,228,228,228,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332
        ],
        classicGreece: [
          30,30,30,83,83,83,83,126,126,126,153,153,153,177,177,177,177,205,205,205,225,225,225,244,244,244,244,268,268,268,285,285,285,301,301,301,301,321,326,331,336,341,346,351,356,361,366,371,376,381,386,391,396,401,406,411,416,421,426,431
        ],
        earlyRome: [
          40,40,40,103,103,103,103,157,157,157,190,190,190,219,219,219,219,255,255,255,280,280,280,303,303,303,303,332,332,332,353,353,353,373,373,373,373,399,405,412,418,425,431,438,444,451,457,464,470,477,483,490,496,503,509,516,522,529,535,542
        ],
        romanEmpire: [
          50,50,50,123,123,123,123,187,187,187,227,227,227,262,262,262,262,304,304,304,334,334,334,362,362,362,362,397,397,397,422,422,422,446,446,446,446,477,487,495,502,510,518,526,534,541,549,557,565,573,580,588,596,604,612,619,627,635,643,651
        ],
        byzantineEra: [
          55,55,55,144,144,144,144,218,218,218,263,263,263,304,304,304,304,354,354,354,388,388,388,421,421,421,421,462,462,462,491,491,491,519,519,519,519,554,565,574,582,591,600,609,618,626,635,644,653,662,670,679,688,697,706,714,723,732,741,750
        ],
        ageOfTheFranks: [
          65,65,65,164,164,164,164,248,248,248,300,300,300,347,347,347,347,404,404,404,443,443,443,480,480,480,480,526,526,526,559,559,559,591,591,591,591,632,644,655,665,675,685,696,706,716,727,737,747,758,768,778,788,799,809,819,830,840,850,861
        ],
        feudalAge: [
          75,75,75,183,183,183,183,277,277,277,335,335,335,387,387,387,387,450,450,450,494,494,494,535,535,535,535,587,587,587,624,624,624,660,660,660,660,705,718,730,741,752,763,775,786,797,809,820,831,843,854,865,876,888,899,910,922,933,944,956
        ],
        iberianEra: [
          83,83,83,201,201,201,201,305,305,305,369,369,369,426,426,426,426,495,495,495,543,543,543,589,589,589,589,646,646,646,686,686,686,726,726,726,726,776,788,801,813,826,838,851,863,876,888,901,913,926,938,951,963,976,988,1001,1013,1026,1038,1051
        ],
        kingdomOfSicily: [
          91,91,91,221,221,221,221,336,336,336,406,406,406,469,469,469,469,545,545,545,597,597,597,648,648,648,648,711,711,711,755,755,755,799,799,799,799,854,870,884,897,911,925,939,953,966,980,994,1008,1022,1035,1049,1063,1077,1091,1104,1118,1132,1146,1160
        ],
        highMiddleAges: [
          100,100,100,243,243,243,243,370,370,370,447,447,447,516,516,516,516,600,600,600,657,657,657,713,713,713,713,782,782,782,831,831,831,879,879,879,879,939,957,973,988,1003,1018,1034,1049,1064,1080,1095,1110,1126,1141,1156,1171,1187,1202,1217,1233,1248,1263,1279
        ],
        earlyGothicEra: [
          102,102,102,251,251,251,251,386,386,386,469,469,469,544,544,544,544,636,636,636,699,699,699,761,761,761,761,838,838,838,893,893,893,947,947,947,947,1015,1024,1040,1056,1072,1088,1104,1120,1136,1152,1168,1184,1200,1216,1232,1248,1264,1280,1296,1312,1328,1344,1360
        ],
        lateGothicEra: [
          108,108,108,266,266,266,266,409,409,409,496,496,496,576,576,576,576,673,673,673,740,740,740,806,806,806,806,887,887,887,945,945,945,1002,1002,1002,1002,1074,1086,1103,1120,1137,1154,1171,1188,1205,1222,1239,1256,1273,1290,1307,1324,1341,1358,1375,1392,1409,1426,1443
        ]
      }),
      CultureRange.asFlat(2),
    ),
  ]),
};

export default PersianPalace;
